const ANALYTICS_ROOT_PATHS = {
    PAYMENT: '/payment',
};
export default ANALYTICS_ROOT_PATHS;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYW5hbHl0aWNzL3BhdGhzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sb0JBQW9CLEdBQUc7SUFDekIsT0FBTyxFQUFFLFVBQVU7Q0FDdEIsQ0FBQztBQUVGLGVBQWUsb0JBQW9CLENBQUMifQ==